import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaAppMobile } from 'styles/grid';

export const MapViewContainer = styled.div`
  ${mediaAppMobile} {
    width: 100%;
    height: 140px;
  }
  width: auto;
  height: 180px;
`;

export const DropOffLocationTitle = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
`;

export const DropOffLocationAddress = styled(Stack).attrs({
  gap: 8,
  direction: 'column',
})`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const OpenNowAndClosed = styled.div`
  font-weight: 600;
`;

export const ViewMoreCTA = styled.button`
  color: ${({ theme }) => theme.configs.CTAButton.bgColor};
  font-weight: 700;
  text-transform: uppercase;
  background: none;
  border: none;
  padding: 0;
  width: fit-content;
  cursor: pointer;
  font-family: inherit;
`;
